import {PipeTransform, Pipe } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import stringUtils from '../shared/Utility/stringUtils';
import DOMPurify from 'dompurify';

// Shared DOMPurify config for rich note HTML — preserves tables, lists, <br>,
// basic inline styles and links while blocking scripts/iframes/event handlers.
// CR-4 / R2-10 / R1 H-10
const DOMPURIFY_RICH_CONFIG: DOMPurify.Config = {
  USE_PROFILES: { html: true },
  ADD_ATTR: ['target', 'colspan', 'rowspan', 'style'],
  FORBID_TAGS: ['style', 'script', 'iframe', 'object', 'embed', 'form'],
  FORBID_ATTR: ['onerror', 'onload', 'onclick'],
};

@Pipe({ name: 'safeHtml' })
export class ParsesafeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }
  transform(value: any, args?: any): any {

    // -----------------------------------------------------------------------------------------------
    // BUG - With <br /> tags above <table...>
    // Adds a bunch of BR tags.
    // See: https://forensicnotes.atlassian.net/wiki/spaces/DEV/pages/2010218515/SafeHtml+BUG
    // -----------------------------------------------------------------------------------------------

    let newVal: string = stringUtils.FixBrBug(value);

    // Sanitize with DOMPurify before handing to Angular's bypass — DOMPurify
    // strips XSS vectors so the subsequent bypass is safe. (CR-4, R2-10)
    const sanitized: string = DOMPurify.sanitize(newVal, DOMPURIFY_RICH_CONFIG) as string;

    return this.sanitizer.bypassSecurityTrustHtml(sanitized);
  }
}

export { DOMPURIFY_RICH_CONFIG };
